// eslint-disable-next-line @tseslint/no-shadow
import { ChangeDetectionStrategy, Component, EventEmitter, inject, input, InputSignal, model, ModelSignal, Output } from '@angular/core';
import { InlineConfirmationComponent } from "../inline-confirmation/inline-confirmation.component";
import { InlineConfirmationMessageComponent } from "../inline-confirmation/components/inline-confirmation-message/inline-confirmation-message.component";
import { InlineConfirmationOperatorsComponent } from "../inline-confirmation/components/inline-confirmation-operators/inline-confirmation-operators.component";
import { InlineConfirmationTriggerDirective } from '../inline-confirmation/directives/inline-confirmation-trigger.directive';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faTrashCan } from '@fortawesome/pro-light-svg-icons';
import { IconModule } from "@ogs-gmbh/ngx-m3-components";
import { MatButtonModule } from '@angular/material/button';
import { InlineConfirmationConfirmDirective } from "../inline-confirmation/directives/inline-confirmation-confirm.directive";
import { InlineConfirmationCancelDirective } from "../inline-confirmation/directives/inline-confirmation-cancel.directive";

@Component({
  selector: 'app-inline-delete-confirmation',
  standalone: true,
  imports: [ InlineConfirmationComponent,
    InlineConfirmationMessageComponent,
    InlineConfirmationOperatorsComponent,
    IconModule,
    MatButtonModule,
    InlineConfirmationConfirmDirective,
    InlineConfirmationCancelDirective ],
  templateUrl: './inline-delete-confirmation.component.html',
  styleUrl: './inline-delete-confirmation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InlineDeleteConfirmationComponent {
  private readonly _faIconLibrary: FaIconLibrary = inject(FaIconLibrary);

  public readonly trigger: InputSignal<InlineConfirmationTriggerDirective | undefined> = input<InlineConfirmationTriggerDirective | undefined>();

  /** If the confirmation should close after the user either confirms or cancels */
  public readonly shouldCloseOnEmit: InputSignal<boolean> = input(true);

  public readonly isOpen: ModelSignal<boolean> = model(false);

  @Output() public readonly cancelEvent: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  @Output() public readonly confirm: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();


  constructor () {
    this._faIconLibrary.addIcons(faTrashCan);
  }


  protected _confirm (pointerEvent: MouseEvent): void {
    this.confirm.emit(pointerEvent);
  }


  protected _cancel (pointerEvent: MouseEvent): void {
    this.confirm.emit(pointerEvent);
  }
}
